module.exports = __webpack_public_path__ + "static/media/specs_icon.763e5386.svg";